module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_2_4.cd2e9b61.jpeg";